import {
  Box,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import FormikControl from '../../../components/common/FormikControl'
import { selectCurrentCycle,updateBatchID } from "../../../slices/common";

const BatchIdUpdate = ({getTimeLine,onClose}) => {
    const currentCycle = useSelector(selectCurrentCycle)
    const LoginData = useSelector((state) => state.loginData);
    const role_slug = LoginData.role_slug;
    const labelQr = currentCycle?.data?.find((it) => it?.slug == "qr-code-generated");
    const cr_raised = labelQr?.completed_date != 'null' && labelQr?.change_requests?.length > 0 && labelQr?.cr_status == 'pending' && role_slug == "logistics-management";
  

    const initialValues = {
     batch_id: currentCycle?.batch_no,
   };

    const dispatch = useDispatch();
    const validationSchema = Yup.object().shape({
    batch_id: Yup.string().required("Please add Batch ID")
    });

  const handleSubmit = async (values) => {
    try {
      // Prepare API payload with the selected restart option
      const payload = {
        subject_id: currentCycle?.subject_id,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,        
        qr_code_id : currentCycle?.type == '2' ? null: currentCycle?.qr_code_generation_id,
        batch_no: values?.batch_id,
        ...cr_raised ? {cr_raised:true}:{}
      };
        const res = await dispatch(updateBatchID(payload)).unwrap();
      if (res?.status === 200) {
       if(getTimeLine)
        getTimeLine()
    if(onClose)
       onClose()
      }
    } catch (err) {
      console.error("Error restarting manufacturing:", err);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const formOptions = [
        {
          label: 'Update Batch ID',
          type: 'text',
          name: 'batch_id',
          placeholder: 'Enter Batch ID',
          required: true,
        }
  ];
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              // loading={isLoading}
              sx={{ backgroundColor: "#3571FF" }}
            >
             Update
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default BatchIdUpdate;
